import React,{useEffect, useState} from 'react';
import { formatMoney } from '../../../../common/money';
import "./SpaSummary.css";
import useAuth from '../../../../customHooks/useAuth';
import { useNavigate,useLocation } from 'react-router-dom';
import PrevIcon from "../../../../assets/icons/coloredPrev.svg"
import axios from 'axios';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../../common/baseUrl';
import PageLoader from '../../../components/PageLoader/PageLoader';
import axiosInstance from '../../../../axiosInstance/axiosInstance';
import { getCurrentUser } from '../../../../common/currentUser';
import PromoSection, { computeDiscount } from '../../FoodSummary/PromoSection';
import { HOTEL_TIMEZONE, toHotelISO } from "../../../../common/hotelTime";

export default function SpaSummary() {


    const navigate = useNavigate();
    const location = useLocation();

    const spaCart = location.state?.spaCart || [];
    const totalPrice= location.state?.totalPrice || "";
    const menu = location.state?.menu || [];
    const bookedRooms = location.state?.bookedRooms || [];
    const userId = localStorage.getItem("user_id");
    
    const hotelId = location.state?.hotelId || "";
    const bookingId = location.state?.bookingId || "";
    const hotelAddress = location.state?.hotelAddress || "";
    const hotelName = location.state?.hotelName || '';
    const checkInDate = location.state?.checkInDate || "";
    const checkOutDate = location.state?.checkOutDate || "";
    const status = location.state?.status || "";
    const activeTab = location.state?.activeTab || "";

    const [errors,setErrors] = useState({});

    // For Number of People
    const [qty,setQty] = useState(1);

    // Loader
    const [isLoading,setIsLoading] = useState(false);

    // Applied promo (offer object | null); the discount tracks the live order amount
    const [appliedPromo,setAppliedPromo] = useState(null);

    const unitTotal = Number(totalPrice) || 0;
    const numericTotal = unitTotal * qty;
    const discountAmount = appliedPromo ? computeDiscount(appliedPromo, numericTotal) : 0;
    const payableTotal = Math.max(0, numericTotal - discountAmount);

    const handleApplyPromo = (offer) => {
        setAppliedPromo(offer);
    };
    const handleRemovePromo = () => {
        setAppliedPromo(null);
    };

    // Handle Refresh
    useAuth();

    // CheckId
    useEffect(()=>{
        const checkId = ()=>{
            if(bookingId==="" || hotelId===""){
                navigate("/bookings");
            }
        } 
        checkId()      
    },[bookingId,hotelId,navigate]);

    const moveBack = ()=>{
        navigate(`/bookings/${bookingId}/requests/new/spa`,{state : {
            spaCart : spaCart,
            spaServices : menu,
            bookedRooms : bookedRooms,
            totalPrice : totalPrice,
            hotelId : hotelId,
            bookingId : bookingId,
            hotelAddress : hotelAddress,
            hotelName : hotelName,
            checkInDate : checkInDate,
            checkOutDate : checkOutDate,
            status  : status,
            activeTab : activeTab,
        }})
    }

    const [formData,setFormData] = useState({
        comment : "",
        serviceDate : "",
        time : "",
        people : qty,
        spaCart : spaCart,
    });

    const validateField = (field,value) => {
        const newErrors = {...errors};
        switch(field) {

            case "time":
                if(!value.trim()){
                    newErrors.time = "Time is Required"
                }
                else{
                    newErrors.time = ""
                }
                break;
            
            // case "comment":
            //     if(!value.trim()){
            //         newErrors.comment = "Comment is Required"
            //     }
            //     else{
            //         newErrors.comment = ""
            //     }
            //     break;

            case "serviceDate" :
                if(!value.trim()){
                    newErrors.serviceDate = "Date is Required";
                }
                else{
                    newErrors.serviceDate = ""
                }
                break;

            default:
                break;
        }
        setErrors(newErrors);

    }
    // For Validation Form
    const validateForm=()=>{
        const newErrors = {};
        // if(!formData.comment){
        //     newErrors.comment = "Comment is Required"
        // }
        if(!formData.time){
            newErrors.time = "Time is Required"
        }
        if(!formData.serviceDate){
            newErrors.serviceDate = "Service Date is Required"
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Return true if no errors
    }

    // Function to handle date selection
    const handleDateSelection = (selectedDate) => {
        setFormData((prevState) => ({
        ...prevState,
        serviceDate: selectedDate,
        }));
        validateField("serviceDate",selectedDate);
    };

    // Handle Change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
        ...prevState,
        [name]: value
        })); 
        validateField(name,value);
    };


    // Format Date
    const formatDate = (date) => {
        return date.toLocaleDateString('en-GB', {
            timeZone: HOTEL_TIMEZONE,
        day: 'numeric',
        month: 'short',
        });
    };

    // Increase Qty
    const increaseQty = () => {
        const newQty = qty + 1;
        setQty(newQty);
        setFormData((prevState) => ({
            ...prevState,
            people: newQty,
        }));
    }

    // Decrease Qty
    const decreaseQty = () => {
        if (qty > 1) {
            const newQty = qty - 1;
            setQty(newQty);
            setFormData((prevState) => ({
                ...prevState,
                people: newQty,
            }));
        }
    }


    // Get today's and tomorrow's date
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);


    const handleSubmit = async()=>{
        try{
            if(!validateForm()){
                // console.log("Please Validate Form");
                return;
            }
            setIsLoading(true);

            // Combine selected date and time into ISO 8601 format
            // Get current year
            const currentYear = new Date().getFullYear();
            // Combine selected date and time into ISO 8601 format
            const selectedDate = new Date(`${formData.serviceDate} ${currentYear}`); // Add current year
            const [hours, minutes] = formData.time.split(':');

            // Set the time to the selected date
            selectedDate.setHours(hours);
            selectedDate.setMinutes(minutes);
            selectedDate.setSeconds(0);

            // Format function without converting to UTC

            // Get the formatted date-time with specified offset
            const isoDateTimeWithInd = toHotelISO(selectedDate);
            // console.log("Date with Offset: ", isoDateTimeWithInd);


            // Convert to ISO format
            // const isoDateTime = selectedDate.toISOString();
            const spa_service_id = spaCart[0].spa_service_id;
            // console.log("Spa Service Id : ",spa_service_id);

            // console.log("Form Data : ",formData);
            try{
                const passData = {
                    additional_comments : formData.comment,
                    number_of_people : formData.people,
                    preferred_time : isoDateTimeWithInd,
                    spa_service_id : spa_service_id,
                    promo_code : appliedPromo?.code || ""
                };
                
                // console.log("Data to be Submitted : ",passData);


                // For Getting The Id Which Has User inside that Room
                const currentUser = await getCurrentUser();
 
                function findMatchedRooms(bookedRooms, usersData) {
                    const contact = usersData.contact;
                    const matchedRooms = bookedRooms.filter((room)=>{
                        // Check if guests are null or an empty array, and skip the room if true
                        if (!room.guests || room.guests.length === 0) {
                            return false; // Skip this room
                        }
                        const matchedGuest = room.guests.find((guest)=>guest.contact===contact);
                        if(matchedGuest) {
                            return true; //
                        }
                        else{
                            return false;
                        }
                    });
                    return matchedRooms;
                }        
      
                const usersData = currentUser;  
                const matchedRooms = findMatchedRooms(bookedRooms, usersData);
      
                if(matchedRooms.length<=0){
                    // console.log("Booking is not Present ");
                    return;
                }
                // console.log("MAtched Rooms : " + matchedRooms[0].id);
 
                const response = await axiosInstance.post(`/api/v1/users/${userId}/bookings/${bookingId}/booked-rooms/${matchedRooms[0].id}/guest-requests/post-checkin/spa-request/`,passData);

                // console.log("Success Request Added : ",response.data);
                // Prefer the server-authoritative discount for the confirmation message.
                const savedAmount = response?.data?.discount_amount ?? (appliedPromo ? discountAmount : 0);
                if (savedAmount > 0) {
                    toast.success(`Spa Request Created! You saved ₹${formatMoney(savedAmount)} 🎉`);
                } else {
                    toast.success("Spa Request Created Successfully");
                }
                navigate("/bookings",{state : {activeRequests : "requests"}});

            }catch(error){
                toast.error(error?.response?.data?.message || "Some Error Occured");
                console.log(error)
            }

        }catch(error){
            console.log(error);
        }
        finally{
            setIsLoading(false);
        }
    }


  return (
    <>
        {
            isLoading && <PageLoader/>
        }
        <div className="spaSummary">
        
            {/* Spa Header */}
            <div className="spaSummary-header">
                <img src={PrevIcon} alt="Error" onClick={moveBack} />
                <h3>Spa Order Summary</h3>
            </div>

            {/* Spa Items */}
            <div className="spaSummary-data">

                {spaCart.map((spa,index)=>(
                    <div className="spaSummary-order" key={index}> 
                        <div className="spaSummary-name">
                            <p>
                                {spa.name} X {spa.quantity}
                            </p>
                        </div>
                        <div className="spaSummary-price">
                            <p>
                                {spa.price} ₹
                            </p>
                        </div>
                    </div>
                ))}
            
            </div>

            <PromoSection
                userId={userId}
                hotelId={hotelId}
                service="Spa"
                orderAmount={numericTotal}
                appliedPromo={appliedPromo}
                discountAmount={discountAmount}
                onApply={handleApplyPromo}
                onRemove={handleRemovePromo}
            />

            {/* Total Price */}
            <div className="foodSummary-bill">
                <div className="foodSummary-bill-row">
                    <p>Subtotal</p>
                    <p>{numericTotal} ₹</p>
                </div>
                {appliedPromo && (
                    <div className="foodSummary-bill-row foodSummary-bill-discount">
                        <p>Discount ({appliedPromo.code})</p>
                        <p>- {discountAmount} ₹</p>
                    </div>
                )}
                <div className="foodSummary-bill-row foodSummary-bill-total">
                    <h4>Total</h4>
                    <h4>{payableTotal} ₹</h4>
                </div>
            </div>


            {/* Note */}
            <div className='spaSummary-note'>
                <h4><span>Note : </span>
                prices are excluding of GST
                </h4>
            </div>

            <div className="spa-form">
                
                {/* Comments */}
                <div className="spa-fields">
                    <h4>Comments</h4>
                    <div className="spaSummary-comment">
                        <textarea name="comment" rows='4' cols="10" onChange={handleChange}></textarea>
                    </div>
                    {errors.comment && <span className="error-message">{errors.comment}</span>}
                </div>


                {/* Number of people */}
                <div className="spa-fields">
                    <h4>Number of People</h4>
                    <div className="spa-people">
                        <div className='qtyButton' onClick={decreaseQty}>-</div>
                        <div className='qty'>{qty}</div>
                        <div className='qtyButton' onClick={increaseQty}>+</div>
                    </div>
                </div>


                {/* Date of Service */}
                <div className="spa-fields">
                    <h4>Date of Service</h4>
                    <div className='date-selection'>
                        <div
                        className={`date-box ${formData.serviceDate === formatDate(today) ? 'selected' : ''}`}
                        onClick={() => handleDateSelection(formatDate(today))}
                        >
                            {formatDate(today)}  
                        </div>
                        <div
                        className={`date-box ${formData.serviceDate === formatDate(tomorrow) ? 'selected' : ''}`}
                        onClick={() => handleDateSelection(formatDate(tomorrow))}
                        >
                            {formatDate(tomorrow)}  
                        </div>
                    </div>
                    {errors.serviceDate && <span className="error-message">{errors.serviceDate}</span>}
                </div>



                {/* Service Time */}
                <div className="spa-fields">
                    <h4>Service Time</h4>
                    <div className="spaSummary-inpGuests">
                        <div className='spaSelect'>
                            <input type="time" name="time" onChange={handleChange}  />    
                        </div>

                        <div className='spa-btn'>
                            <button onClick={handleSubmit} disabled={formData.time==="" || formData.serviceDate===""} >Send Request</button>
                        </div>
                    </div>
                    {errors.time && <span className="error-message">{errors.time}</span>}
                </div>
            </div>
        </div>
    </>
  )
}
